// Which way a key turns the script page, or null. Page Up/Page Down added 19 Oct 2026 so page-turn pedals
// work without setup. Up/Down and Space stay scroll keys (zoomed pages; Space calls cues in calling mode).
const TURNS = { ArrowLeft: 'prev', ArrowRight: 'next', PageUp: 'prev', PageDown: 'next' };

export default function pageTurnFromKey(e) {
    // Don't page the PDF while the user is typing/selecting in an editable
    // field. Covers list-view cells (contenteditable divs AND native
    // <select> cells), the search box, and page-name inputs.
    const ae = e.target;
    const isField = !!ae && (ae.isContentEditable
        || ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.tagName === 'SELECT');
    if (isField) return null;
    return TURNS[e.key] || null;
}


// WEBPACK FOOTER //
// ./src/lib/page-turn-key.js